<template>
  <div>
    <b-card v-for="item in contents" :key="item.title" :title="item.title">
      <div class="d-flex justify-content-start align-items-center mb-1">
        <app-timeline>
          <app-timeline-item
            v-for="element in item.elements"
            :key="element.id"
            :title="element.name"
            :subtitle="getType(element.type).title"
            :icon="getType(element.type).icon"
            :time="GetDateTimeZone(element.rooms[0].pivot.start_in)"
            variant="success"
          />
        </app-timeline>
      </div>
    </b-card>
  </div>
</template>

<script>
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import EduContentController from "@/Controllers/EduContentController";
import Auth from "@/Apis/Auth";
import BCardActions from "@/@core/components/b-card-actions/BCardActions.vue";
import SemesterController from "@/Controllers/SemesterController";
export default {
  components: {
    AppTimeline,
    AppTimelineItem,
    BCardActions,
  },
  props: {
    eduProgram: {},
  },
  data() {
    return {
      contents: [],
      text: "",
      textCh: "",
      load: false,
      GetDateTimeZone: Auth.GetDateTimeZone,
    };
  },
  async created() {
    // let id = localStorage.getItem("eduProgram");
    // let ed = Auth.EDU_PROGRAMS.find((a) => a.id == id);
    let room = Auth.ROOM.find((a) => a.edu_program_id == this.eduProgram.id);

    let res = await new EduContentController().getAllContents(
      this.eduProgram.id,
      {
        room_id: room.id,
      }
    );
    const data = res.sort(function (a, b) {
      var c = new Date(a.rooms[0].pivot.start_in);
      var d = new Date(b.rooms[0].pivot.start_in);
      return c - d;
    });
    const contents = [];
    const numOfSemesters = await new SemesterController().GetAll({
      filter: "edu_program_id|" + this.eduProgram.id,
    });
    numOfSemesters.forEach(semester => {
       const element = data.filter(
        (a) => a.rooms[0].pivot.semester_num == semester.id
      );
      contents.push({ elements: element, title: semester.name });
    });
    this.contents = contents;
  },
  methods: {
    getNumber(number) {
      var ones = [
        "صفر",
        "الفصل الدراسي الاول ",
        "الفصل الدراسي الثانى",
        "الفصل الدراسي الثالث ",
        "الفصل الدراسي الرابع ",
        "الفصل الدراسي الخامس ",
        "الفصل الدراسي السادس",
        "الفصل الدراسي السابع ",
        "الفصل الدراسي الثامن ",
        "الفصل الدراسي التاسع ",
        "الفصل الدراسي العاشر",
        "الفصل الدراسي الحادي عشر ",
        "الفصل الدراسي الثاني عشر ",
        "الفصل الدراسي الثالت عشر ",
        "الفصل الدراسي الرابع عشر",
        "الفصل الدراسي الخامس عشر ",
        "الفصل الدراسي السادس عشر ",
        "الفصل الدراسي السابع عشر ",
        "الفصل الدراسي الثامن عشر",
        "الفصل الدراسي التاسع عشر ",
        "الفصل الدراسي العشرون ",
      ];
      return ones[number];
    },
    getType(type) {
      return new EduContentController().GetType(type);
    },
  },
};
</script>
